export default {
    SET_SESSION_CURRENT: 'SET_SESSION_CURRENT',
    SET_SESSION_TOKEN: 'SET_SESSION_TOKEN',
    SET_SESSION_DATA: 'SET_SESSION_DATA',
    CLEAR_SESSION: 'CLEAR_SESSION',
    SET_SESSION: 'SET_SESSION',
    SET_NOTICE: 'SET_NOTICE'
}
